import { h } from "preact";
import Required from './Required';

const NoteField = ({
  input,
  label,
  required,
}) => {
  return (
    <div style={{ marginBottom: 33 }}>
      Note: {label}
    </div>
  );
};

export default NoteField;



// WEBPACK FOOTER //
// ./components/fields/NoteField.js